<div
  id="flight-status-tracker"
  data-cy="flight-status-tracker"
  class="font-['Whitney']"
>
  <idp-tracker
    *ngIf="content.details && content.details.earnometer"
    [content]="content.details"
    (analyticsData)="analyticsData.emit($event)"
    data-cy="status-tracker"
  ></idp-tracker>
  <div class="m-[15px]">
    <div
      [id]="messageBannerId"
      class="message-banner error-banner"
      *ngIf="content.errors && content.errors.message"
      data-cy="error-banner"
    ></div>
  </div>
  <div
    *ngIf="!content.details || !content.errors"
    class="flex flex-col items-center justify-center min-h-[200px]"
    data-cy="loading-container"
  >
    <div class="page-loader relative" data-cy="page-loader"></div>
    <div class="text-label-sm-medium" data-cy="loading-label">
      {{ this.content.loadingLabel }}
    </div>
  </div>
</div>
